import { Control, FieldValues, Path } from 'react-hook-form'

import { FieldConfig } from '../filter.types'
import { FormControl, FormField, FormItem, FormLabel } from '@ui/Form'

interface FilterFieldRendererProps<T extends FieldValues> {
  fields: FieldConfig<T>[]
  control: Control<T>
}

export const FilterFieldRenderer = <T extends FieldValues>({ fields, control }: FilterFieldRendererProps<T>) =>
  fields.map((field, idx) => {
    if (field.group && fields[idx - 1]?.group === field.group) return null

    if (field.group) {
      const groupFields = fields.filter((f) => f.group === field.group)

      return (
        <div key={`group-${field.group}`} className='flex flex-col gap-2'>
          <FormLabel>{field.label}</FormLabel>
          <div className='flex'>
            {groupFields.map((f) => (
              <FormField
                key={f.name as string}
                control={control}
                name={f.name as Path<T>}
                render={({ field: rhfField }) => <FormControl>{f.element(rhfField)}</FormControl>}
              />
            ))}
          </div>
        </div>
      )
    }

    return (
      <FormField
        key={field.name as string}
        control={control}
        name={field.name as Path<T>}
        render={({ field: rhfField }) => (
          <FormItem className='flex flex-col'>
            <FormLabel>{field.label}</FormLabel>
            <FormControl>{field.element(rhfField)}</FormControl>
          </FormItem>
        )}
      />
    )
  })
